import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { API } from "aws-amplify";
import { useState } from "react";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { CheckAccountStateQuery } from "../../../API";
import { RootState } from "../../../app/store";
import {
  selectPlayer,
  updateAccount,
} from "../../../features/player/playerSlice";
import { selectTheme } from "../../../features/theme/themeSlice";
import { checkAccountState } from "../../../graphql/queries";
import useAccount from "../../../hooks/useAccount";
import ProfileAccountBalance from "./ProfileAccountBalance";
import ProfileMenuContainer from "./ProfileMenuContainer";

type AccountBalanceMenuProps = {
  visible: boolean;
  onClickUrl?: () => void;
  inverse?: boolean;
  onHide?: () => void;
};

const AccountBalanceMenu: React.FC<AccountBalanceMenuProps> = ({
  visible,
  onHide,
}) => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const { accountRefresh } = useAccount();
  const dispatch = useDispatch();
  return (
    <ProfileMenuContainer visible={visible} top={2}>
      <div className="profile-menu-content-p1">
        <div className="d-flex f-row account-balance-refresh">
          <FormattedMessage id="mycredit" />
          <div
            className="pointer"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              accountRefresh();
            }}
          >
            <FontAwesomeIcon icon={faRefresh} />
          </div>
        </div>

        <hr style={{ width: "100%" }} />
        <div className="d-flex f-column account-balance-data">
          <p>
            <FormattedMessage id="withdrawable.balance" />
          </p>

          <div className={`valute valute-${theme.language}`}>
            <p>
              {player.account && (
                <strong>
                  <FormattedNumber
                    value={
                      player.account.deposit -
                      player.account.expenses +
                      player.account.winnings -
                      player.account.pickedUp
                    }
                    style="currency"
                    currency={player.account.valute}
                  />
                </strong>
              )}
            </p>
          </div>

          <p>Bonus</p>

          <div className={`valute valute-${theme.language}`}>
            <p>
              <strong>
                {player.account && (
                  <FormattedNumber
                    value={player.account.bonus}
                    style="currency"
                    currency={player.account.valute}
                  />
                )}
              </strong>
            </p>
          </div>
        </div>
      </div>
    </ProfileMenuContainer>
  );
};

export default AccountBalanceMenu;
